import { nextfetchdata } from '@/shared/api/nextfetch'
import { TShop } from '@/shared/types/product-types'

type ExtendedTShop = TShop & {
	B24_ID: string
}

export const fetchAllStores = async (): Promise<ExtendedTShop[] | void> =>
	await nextfetchdata<ExtendedTShop[]>(`shops`, { credentials: `include` })
